webpackJsonp([126289169546625],{

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n  transition: all 0.125s ease-out;\n  background-size: auto 100%;\n  &:hover {\n    background-size: auto 108%;\n  }\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n    background-size: cover !important;\n  }\n'], ['\n  overflow: hidden;\n  transition: all 0.125s ease-out;\n  background-size: auto 100%;\n  &:hover {\n    background-size: auto 108%;\n  }\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n    background-size: cover !important;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _designSystem = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Photo = _designSystem.BackgroundImage.extend.attrs({ role: 'img' })(_templateObject);
	
	exports.default = Photo;
	module.exports = exports['default'];

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-gap: ', 'px;\n  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));\n  align-items: center;\n  justify-content: center;\n'], ['\n  display: grid;\n  grid-gap: ', 'px;\n  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 16rem;\n'], ['\n  max-width: 16rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _designSystem = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Base = _designSystem.Container.extend(_templateObject, function (props) {
	  return props.theme.space[3];
	});
	
	var Sponsor = _designSystem.Box.withComponent('img').extend(_templateObject2);
	
	var Sponsors = function Sponsors(props) {
	  return _react2.default.createElement(
	    Base,
	    _extends({ maxWidth: 48 }, props),
	    _react2.default.createElement(Sponsor, { alt: 'Mike\u2019s Video', src: '/sponsors/mikes.png' }),
	    _react2.default.createElement(Sponsor, { alt: 'Minitab', src: '/sponsors/minitab.png' }),
	    _react2.default.createElement(Sponsor, { alt: 'Sketch', src: '/sponsors/sketch.png' }),
	    _react2.default.createElement(Sponsor, { alt: 'Ben Franklin', src: '/sponsors/ben-franklin.jpg' }),
	    _react2.default.createElement(Sponsor, { alt: 'Balsamiq', src: '/sponsors/balsamiq.png' })
	  );
	};
	
	exports.default = Sponsors;
	module.exports = exports['default'];

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-gap: ', 'px;\n  width: 100%;\n  > div {\n    width: 100%;\n    box-shadow: ', ';\n    border-radius: ', ';\n    max-width: 100%;\n    min-height: 24rem;\n  }\n  ', ' {\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: ', 'px;\n  }\n'], ['\n  display: grid;\n  grid-gap: ', 'px;\n  width: 100%;\n  > div {\n    width: 100%;\n    box-shadow: ', ';\n    border-radius: ', ';\n    max-width: 100%;\n    min-height: 24rem;\n  }\n  ', ' {\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: ', 'px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _designSystem = __webpack_require__(4);
	
	var _theme = __webpack_require__(23);
	
	var _lodash = __webpack_require__(111);
	
	var _reactHelmet = __webpack_require__(52);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Nav = __webpack_require__(41);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Photo = __webpack_require__(73);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _Action = __webpack_require__(39);
	
	var _Action2 = _interopRequireDefault(_Action);
	
	var _Sponsors = __webpack_require__(74);
	
	var _Sponsors2 = _interopRequireDefault(_Sponsors);
	
	var _Footer = __webpack_require__(40);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Grid = _designSystem.Container.extend(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.space[2];
	}, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.boxShadows[2];
	}, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.radius;
	}, function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.mediaQueries.md;
	}, function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.space[4];
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Nav2.default, null),
	    _react2.default.createElement(
	      _designSystem.Box,
	      { px: 3, pt: [5, 6], pb: 5, bg: 'warm' },
	      _react2.default.createElement(
	        _designSystem.Container,
	        { maxWidth: 48, color: 'white', align: 'center', px: 3 },
	        _react2.default.createElement(
	          _designSystem.Heading.h1,
	          { f: [6, 7], mb: 2 },
	          'Spring 2018 Recap'
	        ),
	        _react2.default.createElement(
	          _designSystem.Heading.h2,
	          { f: [3, 4], m: 0 },
	          'See some photos from our spring event\u2014it was a huge success!'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Grid,
	      { py: [4, 5] },
	      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (n) {
	        return _react2.default.createElement(_Photo2.default, { key: n, image: '/spring_recap/' + n + '.jpg' });
	      })
	    ),
	    _react2.default.createElement(_Sponsors2.default, { pb: 5 }),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.colors = undefined;
	
	var _designSystem = __webpack_require__(4);
	
	var colors = exports.colors = {
	  // greyscale
	  black: '#1f2d3d',
	  steel: '#273444',
	  slate: '#3c4858',
	  muted: '#8492a6',
	  // smoke3: '#c0ccda',
	  // smoke2: '#d3dce6',
	  smoke: '#e0e6ed',
	  // snow3: '#e5e9f2',
	  // snow2: '#eff2f7',
	  snow: '#f9fafc',
	  white: '#ffffff',
	  // brand
	  primary: '#ff5a5f',
	  primaryLight: '#ff7e82',
	  primaryDark: '#e00007',
	  alt: '#007a87',
	  altLight: '#009aab',
	  altDark: '#004f58',
	  success: '#3fb34f',
	  error: '#b23f42',
	  warm: '#ffb400',
	  warmWash: '#ffdc89',
	  cool: '#00bdde',
	  coolWash: '#7cecff'
	  // for DS input
	};colors.blue = [colors.altDark, colors.altLight, colors.altLight];
	colors.info = colors.alt;
	
	_designSystem.theme.colors = colors;
	
	var baseFamily = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif';
	
	var sans = 'Sailec';
	var sansFamily = sans + ',' + baseFamily;
	
	_designSystem.theme.font = sansFamily;
	
	_designSystem.theme.styles = {
	  medium: { style: { fontWeight: 500 } },
	  headline: { f: [5, 6], color: 'black', style: { lineHeight: '1.125' } },
	  subhline: {
	    f: [3, 4],
	    color: 'black',
	    regular: true,
	    style: { lineHeight: '1.375' }
	  },
	  subtext: { f: [3, 4], color: 'black', style: { lineHeight: '1.5' } },
	  contentContainer: {
	    maxWidth: 64,
	    w: 1,
	    p: [3, 2],
	    style: { position: 'relative' }
	  },
	  content: { maxWidth: 48, mx: 0 }
	};
	
	exports.default = _designSystem.theme;

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.theme = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  * { box-sizing: border-box; }\n  body {\n    margin: 0;\n    font-family: ', ';\n    line-height: 1.5;\n  }\n  h2 {\n    line-height: 1.5 !important;\n  }\n  a {\n    box-shadow: none;\n    text-decoration: none;\n  }\n  ul, ol {\n    margin: 0;\n    padding: 0;\n  }\n  h1 + h2,\n  p > a,\n  b {\n    font-weight: 500 !important;\n  }\n  strong {\n    font-weight: 700 !important;\n  }\n'], ['\n  * { box-sizing: border-box; }\n  body {\n    margin: 0;\n    font-family: ', ';\n    line-height: 1.5;\n  }\n  h2 {\n    line-height: 1.5 !important;\n  }\n  a {\n    box-shadow: none;\n    text-decoration: none;\n  }\n  ul, ol {\n    margin: 0;\n    padding: 0;\n  }\n  h1 + h2,\n  p > a,\n  b {\n    font-weight: 500 !important;\n  }\n  strong {\n    font-weight: 700 !important;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _config = __webpack_require__(18);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var theme = exports.theme = _config2.default;
	
	(0, _styledComponents.injectGlobal)(_templateObject, _config2.default.font);
	
	var ThemeProvider = function ThemeProvider(props) {
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: _config2.default },
	    _react2.default.createElement(
	      _react.Fragment,
	      null,
	      props.children
	    )
	  );
	};
	
	exports.default = ThemeProvider;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-recap-js-fe57d7f9c888262cb28e.js